(function() {
  var variantTitles = {
    '50401497514270': 'DYMO LabelWriter Extra Large 4" x 6" Shipping Label Rolls',
    '50401497547038': 'DYMO LabelWriter Extra Large 4" x 6" Shipping Label Rolls',
    '50401497579806': 'DYMO LabelWriter Extra Large 4" x 6" Shipping Label Rolls'
  };

  var timer = null;
  var attempts = 0;

  function applyTitle() {
    var input = document.querySelector('[data-product-form-variant]');
    var titleEl = document.querySelector('h1');
    var variantId = String(input?.value);
    if (variantTitles[variantId] && titleEl) {
      titleEl.textContent = variantTitles[variantId];
    }
  }

  function startWatching() {
    var productInfo = document.querySelector('.product__info');
    if (!productInfo) {
      attempts++;
      if (attempts < 20) setTimeout(startWatching, 500);
      return;
    }
    applyTitle();
    new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(applyTitle, 300);
    }).observe(productInfo, { childList: true, subtree: true });
  }

  setTimeout(startWatching, 1000);
})();